(function () {
    'use strict';

    angular.module("imApp").factory("trNewJobSelectOpService", ['$ihttp', function ($ihttp) {
        let service = {
            listOperationTrs: function (parms) {
                return $ihttp.post({
                    method: 124,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
